export const useKnownPanels = () => {
    const sideNavWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--side-nav-width"));
    const adPanelWidth = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--ad-info-panel-width"));
    const copilotSessionsPanelWidth = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue("--copilot-sessions-panel-width")
    );

    const knownPanels = {
        adSubNav: {
            name: "agent-desktop-sub-nav",
            width: sideNavWidth,
        },
        adCampaignInfo: {
            name: "agent-desktop-campaign-info",
            width: adPanelWidth,
        },
        aiAgents: {
            name: "ai-agents",
            width: sideNavWidth,
        },
        orchestration: {
            name: "orchestration-sub-nav",
            width: sideNavWidth,
        },
        liveOps: {
            name: "live-ops",
            width: sideNavWidth,
        },
        audience: {
            name: "audience",
            width: sideNavWidth,
        },
        convoIntel: {
            name: "convo-intel",
            width: sideNavWidth,
        },
        settings: {
            name: "settings",
            width: sideNavWidth,
        },
        mySettings: {
            name: "my-settings",
            width: sideNavWidth,
        },
        copilotSessions: {
            name: "copilot-sessions",
            width: copilotSessionsPanelWidth,
        },
    } as const;

    return knownPanels;
};
